import classNames from 'classnames';
import React from 'react';

import { WEB_VISOR_HIDE } from 'app/utils/AnalyticsUtils';

interface MonthlyPaymentProps {
    value: string;
    currency: string;
}

export const MonthlyPayment = ({ value, currency }: MonthlyPaymentProps) => {
    return (
        <div className="monthlyPayment">
            <div className="description">Ежемесячный платеж</div>
            <span className={classNames('value', WEB_VISOR_HIDE)}>{value}</span>
            <span className="currency">{currency}</span>
        </div>
    );
};
